import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotes: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="notes">
      <path
        d="M3.5 12H5.5M10 12H12M10 8H14M3.5 8H5.5M3.5 16H5.5M4.5 3.5H19.5V20.5H4.5V3.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconNotes;
